<template>
  <div class="ksm-ursonate__page-wrapper">
    <div class="ksm-flex-1" style="position:relative">
      <div
        v-show="isTextMin"
        title="Bereich wiederherstellen"
        class="ksm-medien__icon-fixed ksm-link--svg2"
        @click="isTextMin=false"
        v-html="$_getSvg('text.svg')"
      ></div>
      <div
        v-show="isNotenMin"
        title="Bereich wiederherstellen"
        class="ksm-medien__icon-fixed--right ksm-link--svg2"
        @click="isNotenMin=false"
        v-html="$_getSvg('noten.svg')"
      ></div>
      <div
        v-show="isAudioMin"
        title="Bereich wiederherstellen"
        class="ksm-medien__icon-fixed--bottom ksm-link--svg2"
        @click="isAudioMin=false"
        v-html="$_getSvg('audio.svg')"
      ></div>
      <g-play-btn
        v-show="isAudioMin"
        :isPlaying="audioIsPlaying"
        @click="audioToggle"
        class="ksm-medien__icon-fixed--bottom ksm-link--svg2"
        style="bottom:20pt"
      ></g-play-btn>
      <div
        v-show="isVideoMin"
        title="Bereich wiederherstellen"
        class="ksm-medien__icon-fixed--bottom_right ksm-link--svg2"
        @click="isVideoMin=false"
        v-html="$_getSvg('film-neu.svg')"
      ></div>
      <splitpanes
        horizontal
        watch-slots
        @resize="resizeRowTop"
        style="height: 100%; width:100%"
        class="default-theme"
        :dbl-click-splitter="false"
      >
        <splitpanes
          watch-slots
          @resize="resizeColumnTopLeft"
          :splitpanes-size="rowTop"
          splitpanes-min="1"
          :dbl-click-splitter="false"
        >
          <div :splitpanes-size="columnTopLeft" splitpanes-min="1" class="ksm-ursonate__pane">
            <div class="ksm-ursonate__box-wrapper">
              <div class="ksm-ursonate__box">
                <TextView :themaPlaying="themaPlaying" :isConnect1="isConnect1"></TextView>
                <OpenCloseButtons
                  v-show="!isNotenMin || !isAudioMin || !isVideoMin"
                  :showMerz24="true"
                  @minimize="minimize('text')"
                  @fullsize="fullsize('text')"
                ></OpenCloseButtons>
              </div>
            </div>
          </div>
          <div :splitpanes-size="100- columnTopLeft" splitpanes-min="1" class="ksm-ursonate__pane">
            <div class="ksm-ursonate__box-wrapper">
              <div class="ksm-ursonate__box">
                <NotenView></NotenView>
                <OpenCloseButtons
                  v-show="!isTextMin  || !isAudioMin || !isVideoMin"
                  @minimize="minimize('note')"
                  @fullsize="fullsize('note')"
                ></OpenCloseButtons>
              </div>
            </div>
          </div>
        </splitpanes>
        <splitpanes
          watch-slots
          @resize="resizeColumnBottomLeft"
          :splitpanes-size="100-rowTop"
          splitpanes-min="1"
          :dbl-click-splitter="false"
        >
          <div :splitpanes-size="columnBottomLeft" splitpanes-min="1" class="ksm-ursonate__pane">
            <div class="ksm-ursonate__box-wrapper">
              <g-connect-btn
                v-show="!isTextMin && !isAudioMin"
                style="position:absolute; top:-35px; left:100px; z-index:300"
                ref="all_play_btn_1"
                @connectClick="doConnect1"
              ></g-connect-btn>
              <g-connect-btn
                style="position:absolute; top:100px; left:-5px; z-index:300"
                rotate="vertical"
                v-show="!isAudioMin && !isVideoMin"
                ref="all_play_btn_2"
                @connectClick="doConnect2"
              ></g-connect-btn>
              <div class="ksm-ursonate__box ksm-flex-x-center">
                <AudioView @audioChange="audioChange" :isConnect2="isConnect2"></AudioView>
                <OpenCloseButtons
                  v-show="!isTextMin || !isNotenMin || !isVideoMin"
                  @minimize="minimize('audio')"
                  @fullsize="fullsize('audio')"
                ></OpenCloseButtons>
              </div>
            </div>
          </div>

          <div
            :splitpanes-size="100- columnBottomLeft"
            splitpanes-min="1"
            class="ksm-ursonate__pane"
          >
            <div class="ksm-ursonate__box-wrapper">
              <div class="ksm-ursonate__box ksm-flex-x-center">
                <FilmView :isConnect2="isConnect2"></FilmView>
                <OpenCloseButtons
                  v-show="!isTextMin || !isNotenMin || !isAudioMin"
                  @minimize="minimize('video')"
                  @fullsize="fullsize('video')"
                ></OpenCloseButtons>
              </div>
            </div>
          </div>
        </splitpanes>
      </splitpanes>
    </div>
  </div>
</template>

<script>
import NotenView from "./ursonate/NotenView";
import TextView from "./ursonate/TextView";
import FilmView from "./ursonate/FilmView";
import AudioView from "./ursonate/AudioView";
import Splitpanes from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import Vue from "vue";

Vue.component("OpenCloseButtons", {
  props: ["showMerz24"],
  data: function() {
    return {
      count: 0
    };
  },
  methods: {
    mini() {
      this.$emit("minimize");
    },
    fullsize() {
      this.$emit("fullsize");
    }
  },
  template: `<div class="ksm-flex" style="height:22px">
  <router-link v-if="showMerz24" tag="div" to="/texte/merzhefte/untersuchungsmodus?merzId=Merz24&seiteIdx=0" class="ksm-medien__icon-s2 ksm-link--svg2" title="Zu Merz 24" @click="fullsize" v-html="$_getSvg('untersuchungsmodus.svg')" style="margin-right:5px"></router-link>
  <span class="ksm-medien__icon-s ksm-link--svg2" title="Bereich maximieren" @click="fullsize" v-html="$_getSvg('oeffnen.svg')" style="margin-right:5px"></span>
  <span class="ksm-medien__icon-s ksm-link--svg2" title="Bereich minimieren" @click="mini" v-html="$_getSvg('schliessen.svg')"></span>
  </div>`
});

export default {
  name: "medienOverview",
  components: { NotenView, TextView, FilmView, AudioView, Splitpanes },
  created: function() {
    this.$store.dispatch("fetchUrsonate");
  },
  computed: {},
  mounted: function() {
    const sp = this.$el.querySelectorAll(".splitpanes__splitter");
    if (sp) {
      sp[1].appendChild(this.$refs.all_play_btn_1.$el);
      sp[2].appendChild(this.$refs.all_play_btn_2.$el);
    }
  },
  data() {
    return {
      rowTop: 50,
      columnTopLeft: 50,
      columnBottomLeft: 50,
      isTextMin: false,
      isNotenMin: false,
      isAudioMin: false,
      isVideoMin: false,
      isConnect1: false,
      isConnect2: false,
      themaPlaying: null,
      audioIsPlaying: false,
      von2: null
    };
  },
  watch: {
    isConnect2(b) {
      if (!b) {
        this.von2 = null;
      }
    },
    isTextMin(b) {
      if (b) {
        // 如果其他都最小化， 返回
        this.columnTopLeft = 0;
        if (this.isNotenMin) {
          this.rowTop = 0;
        }
      } else {
        if (this.rowTop === 0) {
          this.rowTop = 50;
          this.columnTopLeft = 100;
        } else {
          this.columnTopLeft = 50;
        }
      }
    },
    isNotenMin(b) {
      if (b) {
        this.columnTopLeft = 100;
        if (this.isTextMin) {
          this.rowTop = 0;
        }
      } else {
        if (this.rowTop === 0) {
          this.rowTop = 50;
          this.columnTopLeft = 0;
        } else {
          this.columnTopLeft = 50;
        }
      }
    },
    isAudioMin(b) {
      if (b) {
        this.columnBottomLeft = 0;
        if (this.isVideoMin) {
          this.rowTop = 100;
        }
      } else {
        if (this.rowTop === 100) {
          this.rowTop = 50;
          this.columnBottomLeft = 100;
        } else {
          this.columnBottomLeft = 50;
        }
      }
    },
    isVideoMin(b) {
      if (b) {
        this.columnBottomLeft = 100;
        if (this.isAudioMin) {
          this.rowTop = 100;
        }
      } else {
        if (this.rowTop === 100) {
          this.rowTop = 50;
          this.columnBottomLeft = 0;
        } else {
          this.columnBottomLeft = 50;
        }
      }
    }
  },
  methods: {
    audioToggle() {
      if (this.audioIsPlaying) {
        this.$store.state.eventBus.$emit("audio-pause");
      } else {
        this.$store.state.eventBus.$emit("audio-play");
      }
    },
    audioChange({ d, isPlaying }) {
      this.audioIsPlaying = isPlaying;
      //textview + audioview
      if (this.isConnect1) {
        this.themaPlaying = d;
      }
      // console.log(this.von2, this.isConnect2, d);
      if (this.isConnect2 && d && d.von2) {
        if (this.von2 !== d.von2) {
          const curr = d.von2 + (d.currentTime - d.von) * d.playbackRate;
          this.$store.state.eventBus.$emit("video" + "-sync", {
            playbackRate: d.playbackRate,
            currentTime: curr,
            isPlaying: isPlaying
          });
          if (isPlaying) {
            this.von2 = d.von2;
          }
        }
      } else if (this.isConnect2) {
        //console.log("pause", this.von2);
        this.von2 = null;
        this.$store.state.eventBus.$emit("video" + "-pause");
      } else {
        this.von2 = null;
      }
    },
    doConnect1(d) {
      this.isConnect1 = d;
    },
    doConnect2(d) {
      this.isConnect2 = d;
      this.$store.state.eventBus.$emit("audio-connect-2", d);
    },
    resizeRowTop(d) {
      this.rowTop = d[0].width;
    },
    resizeColumnTopLeft(d) {
      this.columnTopLeft = d[0].width;
    },
    resizeColumnBottomLeft(d) {
      this.columnBottomLeft = d[0].width;
    },
    minimize(name) {
      const { isTextMin, isNotenMin, isAudioMin, isVideoMin } = this;
      switch (name) {
        case "text":
          if (isNotenMin && isAudioMin && isVideoMin) {
            return;
          }
          this.isTextMin = true;
          break;
        case "note":
          if (isTextMin && isAudioMin && isVideoMin) {
            return;
          }
          this.isNotenMin = true;
          break;

        case "audio":
          if (isTextMin && isNotenMin && isVideoMin) {
            return;
          }
          this.isAudioMin = true;
          break;

        case "video":
          if (isTextMin && isAudioMin && isNotenMin) {
            return;
          }
          this.isVideoMin = true;
          break;
      }
    },
    fullsize(name) {
      const { isTextMin, isNotenMin, isAudioMin, isVideoMin } = this;
      switch (name) {
        case "text":
          this.isTextMin = false;
          this.isNotenMin = true;
          this.isAudioMin = true;
          this.isVideoMin = true;
          break;
        case "note":
          this.isTextMin = true;
          this.isNotenMin = false;
          this.isAudioMin = true;
          this.isVideoMin = true;
          break;

        case "audio":
          this.isTextMin = true;
          this.isNotenMin = true;
          this.isAudioMin = false;
          this.isVideoMin = true;
          break;

        case "video":
          this.isTextMin = true;
          this.isNotenMin = true;
          this.isAudioMin = true;
          this.isVideoMin = false;
          break;
      }
    }
  }
};
</script>

<style lang="scss" >
.ksm-ursonate__page-wrapper {
  @extend .ksm-flex-column;
  background-color: #fff;
  padding: 30px;
  position: relative;
}
.ksm-ursonate__box-wrapper {
  @extend .ksm-flex-1;
  background-color: #eee;
  margin: 10px;
  position: relative;
}

.ksm-ursonate__box {
  @extend .ksm-flex;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0px;
}

.ksm-ursonate__pane {
  @extend .ksm-flex;
  height: 100%;
  width: 100%;
  min-width: 30px;
  min-height: 30px;
}

.splitpanes__pane1 span {
  font-family: Helvetica, Arial, sans-serif;
  color: #fff;
  font-size: 5em;
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// MedienOverview.vue?05f8b97c